/**
 * Shrinkage calculation utilities for org config.
 * Uses paidHoursPerDay and paidHoursPerYear as base inputs.
 */
export function calcPaidHoursPerYear(paidHoursPerDay, workingDaysPerYear) {
    return paidHoursPerDay * workingDaysPerYear;
}
export function calcPaidHoursPerWeek(paidHoursPerYear) {
    return paidHoursPerYear / 52;
}
export function calcPaidHoursPerWeekFromDayAndWeek(paidHoursPerDay, workingDaysPerWeek) {
    return paidHoursPerDay * workingDaysPerWeek;
}
export function calcPaidDaysPerWeek(workingDaysPerWeek) {
    return workingDaysPerWeek;
}
export function hoursFromDays(daysPerYear, paidHoursPerDay) {
    return daysPerYear * paidHoursPerDay;
}
export function daysFromHours(hoursPerYear, paidHoursPerDay) {
    return paidHoursPerDay > 0 ? hoursPerYear / paidHoursPerDay : 0;
}
export function percentFromHours(hoursPerYear, paidHoursPerYear) {
    return paidHoursPerYear > 0 ? (hoursPerYear / paidHoursPerYear) * 100 : 0;
}
export function hoursFromPercent(percentShrinkage, paidHoursPerYear) {
    return (percentShrinkage / 100) * paidHoursPerYear;
}
export function hoursPerMonthFromHoursPerYear(hoursPerYear) {
    return hoursPerYear / 12;
}
export function hoursPerWeekFromHoursPerYear(hoursPerYear) {
    return hoursPerYear / 52;
}
/**
 * Total Shrinkage = OOS + (1 - OOS) * IOS
 * OOS = out-of-office shrinkage (capacity loss outside scheduled production)
 * IOS = in-office shrinkage (capacity loss during scheduled hours)
 */
export function calcTotalShrinkage(oosPercent, iosPercent) {
    var oos = oosPercent / 100;
    var ios = iosPercent / 100;
    return (oos + (1 - oos) * ios) * 100;
}
export function round2(value) {
    return Math.round(value * 100) / 100;
}
